<wbo-edit-page #editPage [title]="model.data.name">
    <fui-formation-group-template *formationGroup="{title: 'wbo.course.edit.formation.details', formControlNames: ''}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name"
                                               [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-columns>
                    <fui-column>
                        <wbo-edit-grid [data]="model.data.courses" [editable]="true" [removable]="true"
                                       [entityPath]="'courses'" [reorderable]="true">
                            <wbo-text-column field="name" [editable]="true"></wbo-text-column>
                            <wbo-checkbox-column field="callAway"
                                                 [editable]="true"></wbo-checkbox-column>
                            <wbo-numeric-column field="warningMinutes"
                                                [editable]="true"
                                                [cellEnabler]="enableIfCallAway"></wbo-numeric-column>
                            <wbo-color-column field="rgbaColour"
                                              [editable]="true"></wbo-color-column>
                            <wbo-single-select-column field="resdiary_mealstatus"
                                                      *ngIf="(License.RESDIARY | booleanConfig)"
                                                      [editable]="true" placeholder="' '">
                                <wbo-select-options>
                                    <wbo-select-option [value]="CourseData.RESDIARY_MEAL_STATUS_DRINKS"
                                                       label="wbo.course.option.resdiaryMealstatus.drinks">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="CourseData.RESDIARY_MEAL_STATUS_STARTER"
                                                       label="wbo.course.option.resdiaryMealstatus.starter">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="CourseData.RESDIARY_MEAL_STATUS_MAIN"
                                                       label="wbo.course.option.resdiaryMealstatus.main">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="CourseData.RESDIARY_MEAL_STATUS_DESSERT"
                                                       label="wbo.course.option.resdiaryMealstatus.dessert">
                                    </wbo-select-option>
                                </wbo-select-options>
                            </wbo-single-select-column>
                            <wbo-single-select-column field="openTableTableStatus"
                                                      *ngIf="(License.OPENTABLE | booleanConfig)"
                                                      [editable]="true" placeholder="' '">
                                <wbo-select-options>
                                    <wbo-select-option [value]="CourseData.OPENTABLE_TABLE_STATUS_APPETIZER"
                                                       label="wbo.course.option.openTableTableStatus.appetizer">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="CourseData.OPENTABLE_TABLE_STATUS_ENTREE"
                                                       label="wbo.course.option.openTableTableStatus.entree">
                                    </wbo-select-option>
                                    <wbo-select-option [value]="CourseData.OPENTABLE_TABLE_STATUS_DESSERT"
                                                       label="wbo.course.option.openTableTableStatus.dessert">
                                    </wbo-select-option>
                                </wbo-select-options>
                            </wbo-single-select-column>
                            <wbo-edit-grid-add-row>
                                <wbo-edit-grid-add-row-actions>
                                    <wbo-edit-grid-add-row-new></wbo-edit-grid-add-row-new>
                                </wbo-edit-grid-add-row-actions>
                            </wbo-edit-grid-add-row>
                        </wbo-edit-grid>
                    </fui-column>
                </fui-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
